<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate">Inicio</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'Inicio' }]" />
    </div>
  </section>

  <section wrapper class="p-5">
    <h1 class="fw-light m-0 text-center text-muted">Bienvenido, {{ this.user?.firstName }}.</h1>
  </section>
</backbone>
